import { css } from 'aphrodite';
import * as React from 'react';
import { Collapsible, CollapsiblePanel, CollapsibleTrigger } from '../../../../web/components-v2/Collapsible';
import { RightChevron } from '../../../../web/components/svgs/icons/RightChevron';
import { styleSheet } from '../styles';

interface IProps {
	children: React.ReactNode;
	title: string;
}

export const DrawerSection: React.FC<IProps> = ({ children, title }) => (
	<Collapsible defaultOpen className={css(styleSheet.drawerSection)}>
		<CollapsibleTrigger className={css(styleSheet.sectionTrigger)}>
			{title}
			<RightChevron height={14} className={css(styleSheet.sectionChevron)} />
		</CollapsibleTrigger>
		<CollapsiblePanel>
			<div className={css(styleSheet.sectionBody)}>{children}</div>
		</CollapsiblePanel>
	</Collapsible>
);
